namespace RecordShield.Workspace {
    export interface ProductsRow {
        Id?: number;
        Code?: number;
        Name?: string;
        Description?: string;
        AuthorName?: string;
        AuthorPhoto?: string;
        AuthorDescription?: string;
        UserId?: number;
        eViews?: Models.EViews;
        Views?: number;
        eWatchTime?: Models.EWatchTime;
        WatchTime?: number;
        Size?: number;
        CustomerKey?: number;
        eValidity?: Models.EValidity;
        ValidityInDays?: number;
        UpdateFrequencyInDays?: number;
        AllowSecondScreen?: boolean;
        TotalAllowedDuration?: number;
        AllowedDevices?: Models.Enums.AllowedDevices;
        IsActive?: number;
        EncryptionPath?: string;
        SupportInfo?: string;
        Credit?: number;
        CreditRequired?: number;
        TotalDuration?: number;
        FacultyEmail?: string;
        FacultyMobile?: number;
        TenantId?: number;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserPasswordHash?: string;
        UserPasswordSalt?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserIsdCode?: string;
        UserMobile?: string;
        UserParentId?: number;
        UserPackageId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductsRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Workspace.Products';
        export const lookupKey = 'Workspace.Products';

        export function getLookup(): Q.Lookup<ProductsRow> {
            return Q.getLookup<ProductsRow>('Workspace.Products');
        }

        export namespace Fields {
            export declare const Id: string;
            export declare const Code: string;
            export declare const Name: string;
            export declare const Description: string;
            export declare const AuthorName: string;
            export declare const AuthorPhoto: string;
            export declare const AuthorDescription: string;
            export declare const UserId: string;
            export declare const eViews: string;
            export declare const Views: string;
            export declare const eWatchTime: string;
            export declare const WatchTime: string;
            export declare const Size: string;
            export declare const CustomerKey: string;
            export declare const eValidity: string;
            export declare const ValidityInDays: string;
            export declare const UpdateFrequencyInDays: string;
            export declare const AllowSecondScreen: string;
            export declare const TotalAllowedDuration: string;
            export declare const AllowedDevices: string;
            export declare const IsActive: string;
            export declare const EncryptionPath: string;
            export declare const SupportInfo: string;
            export declare const Credit: string;
            export declare const CreditRequired: string;
            export declare const TotalDuration: string;
            export declare const FacultyEmail: string;
            export declare const FacultyMobile: string;
            export declare const TenantId: string;
            export declare const UserUsername: string;
            export declare const UserDisplayName: string;
            export declare const UserEmail: string;
            export declare const UserSource: string;
            export declare const UserPasswordHash: string;
            export declare const UserPasswordSalt: string;
            export declare const UserInsertDate: string;
            export declare const UserInsertUserId: string;
            export declare const UserUpdateDate: string;
            export declare const UserUpdateUserId: string;
            export declare const UserIsActive: string;
            export declare const UserLastDirectoryUpdate: string;
            export declare const UserUserImage: string;
            export declare const UserIsdCode: string;
            export declare const UserMobile: string;
            export declare const UserParentId: string;
            export declare const UserPackageId: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'Code', 'Name', 'Description', 'AuthorName', 'AuthorPhoto', 'AuthorDescription', 'UserId', 'eViews', 'Views', 'eWatchTime', 'WatchTime', 'Size', 'CustomerKey', 'eValidity', 'ValidityInDays', 'UpdateFrequencyInDays', 'AllowSecondScreen', 'TotalAllowedDuration', 'AllowedDevices', 'IsActive', 'EncryptionPath', 'SupportInfo', 'Credit', 'CreditRequired', 'TotalDuration', 'FacultyEmail', 'FacultyMobile', 'TenantId', 'UserUsername', 'UserDisplayName', 'UserEmail', 'UserSource', 'UserPasswordHash', 'UserPasswordSalt', 'UserInsertDate', 'UserInsertUserId', 'UserUpdateDate', 'UserUpdateUserId', 'UserIsActive', 'UserLastDirectoryUpdate', 'UserUserImage', 'UserIsdCode', 'UserMobile', 'UserParentId', 'UserPackageId', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
